<template>
  <v-text-field
    :loading="loading"
    density="compact"
    variant="solo"
    clear-icon="mdi-close-circle"
    clearable
    label="جستجوی محصولات"
    prepend-inner-icon="mdi-magnify"
    single-line
    hide-details
    v-model="searchKeyword"
    @click:prepend-inner="onClick"
    @keyup.enter="onEnter"
    @input="onInput"
    @click:clear="onClear"
  ></v-text-field>
</template>

<script>
export default {
  data: () => ({
    loaded: false,
    loading: false,
    searchKeyword: null,
    searchTimeout: null,
  }),

  methods: {
    onClick() {
      this.performSearch()
    },

    onEnter() {
      // Clear any pending debounced search
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }
      this.performSearch()
    },

    onInput() {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      // Set new timeout for debounced search (500ms delay)
      this.searchTimeout = setTimeout(() => {
        this.performSearch()
      }, 500)
    },

    onClear() {
      this.searchKeyword = ''
      this.performSearch()
    },

    performSearch() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.loaded = true
      }, 1000)
      this.$emit('search', this.searchKeyword)
    },
  },

  beforeDestroy() {
    // Clean up any pending timeouts
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
}
</script>

<style lang="scss" scoped></style>
